import { type ReactElement, useEffect } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import Link from 'next/link'
import { useSnapshot } from 'valtio'
import Breadcrumbs from '../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { APP_TRANSACTIONS_PATH } from '../../../../pages/app/transactions'
import { executeTransactionRetrieve } from '../../../../shared/apiUtils/executeTransactionRetrieve'
import { determineBrowserTabName } from '../../../../shared/themes/logoFunctions'
import { buildAppTransactionIdRefundsNewPath } from '../../../../pages/app/transactions/[id]/refunds/new'
import { transactionProxy } from '../../../../shared/proxies/transactionProxy'
import TransactionStatusLabel from '../../../../shared/components/ui/TransactionStatusLabel'
import RedOutlineButton from '../../../../shared/components/ui/buttons/RedOutlineButton'
import { TransactionErrorContainer } from '../index/TransactionsTable/components/TransactionErrorContainer'
import { GlobalTransactionStatus } from '../../../../shared/types/GlobalTransactionStatus'
import { TransactionMainSection } from './components/TransactionMainSection'
import { CustomerSection } from './components/CustomerSection'
import { RelatedTransactionsTable } from './relatedTransactionsTable/RelatedTransactionsTable'

export function Container (): ReactElement {
  const router = useRouter()
  const { id } = router.query
  const { transaction } = useSnapshot(transactionProxy)

  const notFullyRefunded = (transaction?.remainingAmountCents || 0) > 0
  const isSuccess = transaction?.status === GlobalTransactionStatus.Complete

  useEffect(() => {
    if (!id) { return }
    void executeTransactionRetrieve(id as string)
  }, [id])

  return (
    <>
      <Head>
        <title>{`Transaction ${id as string} - ${determineBrowserTabName()}`}</title>
      </Head>

      <div className="flex flex-row justify-between mb-4">
        <Breadcrumbs breadcrumbs={[{ path: APP_TRANSACTIONS_PATH, text: 'Transactions' }, { text: (id as string) }]} />

        <div className="flex flex-row justify-end">
          {notFullyRefunded && isSuccess && (
            <Link href={buildAppTransactionIdRefundsNewPath(id as string)}>
              <RedOutlineButton
                clickFunction={() => { return null }}
                text="Refund Transaction"
              />
            </Link>
          )}
          <div className="ml-4 mt-1">
            <TransactionStatusLabel status={transaction?.status} />
          </div>
        </div>

      </div>
      <div className="flex flex-row">
        <TransactionMainSection />
        <div className="flex flex-col w-2/5">
          <TransactionErrorContainer />
          <CustomerSection />
        </div>

      </div>
      <div className="w-full">
        <RelatedTransactionsTable />
      </div>

    </>
  )
}
